import React from 'react';
import '../../styles/corpoClinico.css';
import Psiquiatra from '../../img/corpoClinico/psiquiatra.jpg';
import SemFoto  from '../../img/corpoClinico/sem_foto.jpg';
import Zampiroli from '../../img/corpoClinico/Zampirolli.webp';

const CorpoClinico: React.FC = () => {
  return (
    <>
      <div className='title_clinic'>
        <h2 className="titulo" id="Corpo_Clinico_Psiquiatria">Corpo Clínico</h2>
      </div>
      <div className="corpo-clinico">
        <div className="zoom_corpo_clinico">
          <div className="corpo-clinico-container">
            <div className="imagem-container">
              <img src={Psiquiatra} alt="Douglas" />
            </div>
            <div className="info-container">
              <h3 className="nome">Douglas</h3>
              {/*<a href="https://lattes.cnpq.br/9350331289823529"
                target="_blank"
                rel="noopener noreferrer" className="btn-saber-mais">Saiba mais</a>*/}
              <p className="descricao">
                "Médico Psiquiatra, Douglas é médico psiquiatra com formação pela Universidade Federal do Rio Grande do Sul (UFRGS), tendo realizado Graduação Sanduíche na Chung-Ang University, em Seul, Coreia do Sul. Concluiu Residência Médica em Psiquiatria pelo Hospital Psiquiátrico São Pedro e especializou-se em Psiquiatria da Infância e Adolescência no Hospital Materno-Infantil Presidente Vargas. Possui ainda formação em Psicoterapia Cognitivo-Comportamental pela Clínica Wainer. Atualmente, é Chefe da Seção de Psiquiatria da Policlínica Militar de Porto Alegre e atua como psiquiatra da infância e adolescência na Equipe Especializada em Crianças e Adolescentes Navegantes, em Porto Alegre. Também integra o ambulatório de Psiquiatria do município de Barra do Ribeiro, contribuindo com sua experiência no cuidado à saúde mental de crianças, adolescentes e adultos."
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="space"><br /></div>

      <div className="corpo-clinico">
        <div className="zoom_corpo_clinico">
          <div className="corpo-clinico-container">
            <div className="imagem-container">
              <img src={Zampiroli} alt="Dr. Zampiroli" />
            </div>
            <div className="info-container">
              <h3 className="nome">Dr. Zampiroli</h3>
              {/*<a href="https://lattes.cnpq.br/3793773525515055"
                target="_blank"
                rel="noopener noreferrer" className="btn-saber-mais">Saiba mais</a>*/}
              <p className="descricao">
                "Dr. Wheber Christiano Zampirollo é médico psiquiatra, formado pela UFRJ (IPUB), com ampla experiência no cuidado da saúde mental. Possui formação em psicoterapia e especialização em Psiquiatria Forense, atuando há muitos anos no atendimento de crianças, adultos e idosos.

É médico de carreira da Força Aérea Brasileira desde 2009 e atualmente é Chefe do Serviço de Psiquiatria do Hospital de Aeronáutica de Canoas (RS). Atua em consultório desde 2008, realizando atendimentos presenciais e on-line.

Seu trabalho é voltado para oferecer um cuidado acolhedor, ético e individualizado, com escuta atenta e tratamento baseado no conhecimento científico, respeitando as necessidades e a história de cada paciente.

CRM: 41000 – RS

Atendimento: Presencial e on-line  "
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="botao-container"></div>
      <div className="botao-container">
        <br></br>
      </div>
    </>
  );
};

export default CorpoClinico;